import { Component, Input, OnChanges, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { StoreService } from 'core/services/store.service';
import { GroupsListService } from './groups-list.service';

@Component({
  selector: 'lms-groups-list',
  templateUrl: './groups-list.component.html',
  styleUrls: ['./groups-list.component.scss'],
  providers: [GroupsListService]
})
export class GroupsListComponent implements OnInit, OnChanges, OnDestroy {
  @Input() listId: string;
  @Input() options: any;
  public dataSource: any;

  constructor(public router: Router, public groupsListService: GroupsListService) {}

  async ngOnInit() {}

  async ngOnChanges() {
    this.dataSource = await this.groupsListService.getDatasource(this.listId, this.options);
  }

  ngOnDestroy() {
    StoreService.remove(this.listId);
  }

  onClickRow(group) {
    this.router.navigate(['/groups', group.id]);
  }

  onDatasourceUpdate(dataSource) {
    this.dataSource = dataSource;
    StoreService.update(this.listId, this.dataSource);
  }
}
